import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowLeft, Phone, CalendarCheck, CheckCircle2 } from "lucide-react";
import { SERVICES, SERVICE_DETAIL, BUSINESS } from "@/lib/constants";

export default function ServiceDetail() {
  const { slug } = useParams();
  const service = SERVICES.find((s) => s.slug === slug);
  const detail = SERVICE_DETAIL[slug];

  if (!service || !detail) return <Navigate to="/services" replace />;

  return (
    <div data-testid={`service-detail-${slug}`} className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <Link to="/services" data-testid="back-to-services" className="inline-flex items-center gap-2 text-navy font-semibold mb-6 hover:text-gold">
        <ArrowLeft className="w-5 h-5" /> All Services
      </Link>

      <h1 className="font-heading text-4xl sm:text-5xl font-bold text-black">{service.name}</h1>

      <div className="mt-10 space-y-8">
        <Block title="What This Ticket Means" text={detail.what} />
        <Block title="Possible Consequences" text={detail.consequences} />
        <Block title="How We Can Help" text={detail.help} />
      </div>

      <div className="mt-10 bg-white border-t border-slate-200 pt-10 text-center">
        <h2 className="font-heading text-2xl sm:text-3xl font-bold text-black">Get Help With Your {service.name}</h2>
        <p className="mt-2 text-lg text-gray-700">Submit your ticket now or call — we're open 8 AM – 10 PM daily.</p>
        <div className="mt-6 flex flex-col sm:flex-row justify-center gap-3">
          <Link to="/consultation" className="btn-primary" data-testid="service-consult-btn"><CalendarCheck className="w-5 h-5" /> Book Free Consultation</Link>
          <a href={`tel:${BUSINESS.phoneRaw}`} className="btn-primary" data-testid="service-call-btn">
            <Phone className="w-5 h-5" /> Call {BUSINESS.phone}
          </a>
        </div>
      </div>
    </div>
  );
}

function Block({ title, text }) {
  return (
    <div className="bg-white border border-slate-200 rounded-lg p-6">
      <h2 className="font-heading text-2xl font-semibold text-black flex items-center gap-2">
        <CheckCircle2 className="w-6 h-6 text-gold" /> {title}
      </h2>
      <p className="mt-3 text-lg text-gray-800 leading-relaxed">{text}</p>
    </div>
  );
}
